module.exports = __webpack_public_path__ + "img/pagoLinea.b140e21d.svg";